import DefaultPage from '@components/defaultPage';
import HistoryWidget from '@components/historyWidget';
import Title from '@components/title';
import { useTranslator } from '@i18n';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_location/log/')({
  component: LogPage,
});

function LogPage() {
  const t = useTranslator();

  return (
    <Title title={t('log.title')}>
      <DefaultPage title={t('log.title')}>
        <HistoryWidget />
      </DefaultPage>
    </Title>
  );
}
